import { defineMessages } from 'react-intl';

export default defineMessages({
  sitesDataGridColumnsSiteTypeTooltipDeprecated: {
    defaultMessage: 'New site types are available. Open the site detail to choose the one that best fits your project.',
    id: 'sitesDataGrid.columns.siteType.tooltipDeprecated',
  },
});
